// WEB3 · Оверлей для стрима (~480×160). Компактная полоска счёта для наложения в OBS:
// прозрачный фон rgba(11,11,10,0.84) + blur, LIVE-блок + СИН/КРАС очки + текущий сет.
// Только просмотр.

import { computeState, type Match, type Snapshot } from './engine';
import { teamName } from './view';

export class Overlay {
  private root: HTMLElement;

  constructor(root: HTMLElement) {
    this.root = root;
    this.root.classList.add('wb-overlay-host');
  }

  render(match: Match, mode: 'live' | 'demo'): void {
    const s = computeState(match);
    this.root.innerHTML = this.markup(s, mode);
  }

  private markup(s: Snapshot, mode: 'live' | 'demo'): string {
    const finished = s.status === 'finished';
    const live = mode === 'live' && !finished;
    const setNo = s.completedSets.length + 1;
    // Короткие метки команд: первые 3 символа имени в верхнем регистре, иначе СИН/КРАС.
    const labelA = shortLabel(teamName(s, 'A'), 'СИН');
    const labelB = shortLabel(teamName(s, 'B'), 'КРАС');

    return `
      <div class="ov" data-screen="overlay">
        <div class="ov-strip">
          <div class="ov-live ${live ? '' : 'ov-live--off'}">
            <span class="ov-live__dot"></span>
            <span class="ov-live__txt">${finished ? 'ИТОГ' : live ? 'LIVE' : 'ДЕМО'}</span>
          </div>
          <div class="ov-team ov-team--a">
            <span class="ov-chip ov-chip--a"></span>
            <span class="ov-lbl">${escapeHtml(labelA)}</span>
            <span class="ov-pt ov-pt--a" data-points="A">${escapeHtml(s.displayA)}</span>
          </div>
          <div class="ov-divider"></div>
          <div class="ov-team ov-team--b">
            <span class="ov-pt ov-pt--b" data-points="B">${escapeHtml(s.displayB)}</span>
            <span class="ov-lbl">${escapeHtml(labelB)}</span>
            <span class="ov-chip ov-chip--b"></span>
          </div>
          <div class="ov-set">
            <span class="ov-set__cap">СЕТ ${setNo}</span>
            <span class="ov-set__games" data-games>${s.gamesA}–${s.gamesB}</span>
          </div>
        </div>
      </div>
    `;
  }
}

function shortLabel(name: string, fallback: string): string {
  const trimmed = name.trim();
  if (!trimmed) return fallback;
  return trimmed.slice(0, 4).toUpperCase();
}

function escapeHtml(str: string): string {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
